import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';

const Wrapper = styled('div')(({ slides }) => ({
  flex: slides === 'true' ? 0 : 1,
  borderRadius: 15,
  background: 'linear-gradient(180deg, #2eb0c4 0%, #2ab0b5 100%)'
}));

const Title = styled(Typography)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.white.main}`,
  color: theme.palette.white.main,
  padding: '10px 25px',
  [theme.breakpoints.down('md')]: {
    lineHeight: '34px'
  },
  [theme.breakpoints.down('sm')]: {
    lineHeight: '34px',
    fontSize: 24,
    padding: '16px 25px'
  }
}));

const Text = styled(Typography)(({ theme }) => ({
  color: theme.palette.white.main,
  padding: '10px 25px',
  fontSize: 16
}));

const ScheduleComponent = ({ professionInfo, t, slides }) => {
  const workEnvironment = professionInfo?.workEnvironment;
  
  // Hide component if workEnvironment is empty or missing
  if (!workEnvironment || !workEnvironment.trim()) {
    return null;
  }

  return (
    <Wrapper slides={`${slides}`}>
      <Title variant={'h2'}>{t('Schedule')}</Title>
      <Text variant="body1">{workEnvironment}</Text>
    </Wrapper>
  );
};

export default ScheduleComponent;
